import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's stock scales. The tokens declared in
 * index.css (`rounded-control|card|pill|button|chip|panel|round`, `shadow-e1..e4`, `text-2xs`, the
 * `z-*` kit layers) have to be registered here, otherwise `text-2xs` is read as
 * a text COLOR and silently drops (or is dropped by) `text-ink`, and
 * `rounded-card` fails to override `rounded-control`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      borderRadius: ['control', 'card', 'pill', 'button', 'chip', 'panel', 'round'],
    },
    classGroups: {
      'font-size': [{ text: ['2xs'] }],
      shadow: [{ shadow: ['e1', 'e2', 'e3', 'e4'] }],
      z: [{ z: ['dialog', 'dialog-content', 'popover', 'tooltip', 'toast'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
